import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Link } from 'react-router-dom';
import { useQuery } from 'urql';
import cc from 'classcat';
import { ERROR_MESSAGE } from './constants';
import { getQuickActions } from './queries';
import categoryCSS from './Category.module.scss';
import css from './QuickActions.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var QuickActions = function QuickActions() {
  var _useQuery = useQuery({
    query: getQuickActions
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error;

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: ERROR_MESSAGE
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h2", {
      className: categoryCSS.title,
      children: "Quick Actions"
    }), fetching && /*#__PURE__*/_jsx("ul", {
      className: css.list,
      "aria-busy": "true",
      children: new Array(6).fill().map(function (_, idx) {
        return /*#__PURE__*/_jsxs("li", {
          className: css.item,
          children: [/*#__PURE__*/_jsx("div", {
            className: cc([css.icon, css.loading])
          }), /*#__PURE__*/_jsx("div", {
            className: css.loading,
            children: "\xA0"
          })]
        }, idx);
      })
    }), !fetching && data && /*#__PURE__*/_jsx("ul", {
      className: css.list,
      children: data.faqsQuickActions.edges.map(function (_ref) {
        var _ref$node = _ref.node,
            id = _ref$node.id,
            slug = _ref$node.slug,
            title = _ref$node.title,
            icon = _ref$node.icon;
        return /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsxs(Link, {
            "aria-label": "Navigate to the ".concat(title, " section"),
            to: slug,
            children: [/*#__PURE__*/_jsx("div", {
              className: css.icon,
              dangerouslySetInnerHTML: {
                __html: icon
              }
            }), title]
          })
        }, id);
      })
    })]
  });
};

export default QuickActions;